import * as React from "react"

import { cn } from "@/lib/utils"

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "bg-white/5 border-white/5 text-white placeholder:text-slate-600 h-12 w-full rounded-2xl border px-6 text-sm shadow-inner transition-all focus:border-blue-500/50 focus:ring-4 focus:ring-blue-500/10 outline-none disabled:opacity-50",
        className
      )}
      {...props}
    />
  )
}

export { Input }
